export default "__VITE_ASSET__DNRCbF14__"